import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { Meta } from '@df/core/meta/meta';
import { Customer } from '@df/session/api/customer';
import { CustomerNotLoggedGuard } from '@df/session/customer/customer-not-logged.guard';
import { Subscription } from 'rxjs';
@Component({
    selector: 'login-view',
    template: '<router-outlet></router-outlet>',
    standalone: true,
    imports: [RouterOutlet]
})
export class LoginViewComponent implements OnInit, OnDestroy {
    protected subscriptions: Subscription = new Subscription();

    /**
     * Guard checking if custmer is NOT logged in
     */

    protected customerNotLoggedGuard = inject(CustomerNotLoggedGuard);

    private meta = inject(Meta);

    protected metaRouterSubscription?: Subscription;

    constructor(readonly customer: Customer) {}

    /**
     * On init hook to listen to customer mocdel status changes
     */
    ngOnInit() {
        this.subscriptions.add(
            this.customer.model.obs.status.subscribe(() => {
                if (!this.customerNotLoggedGuard.isCustomerAllowed()) {
                    this.onLoggedInCheck();
                }
            })
        );
    }

    onLoggedInCheck(): void {
        if (!this.customerNotLoggedGuard.isCustomerAllowed()) {
            if (this.meta.busy) {
                if (!this.metaRouterSubscription) {
                    this.metaRouterSubscription = this.meta.routerEvents.subscribe(() => this.onLoggedInCheck());
                }
            } else {
                this.customerNotLoggedGuard.onError();
            }
        } else {
            this.unsubscribeFromMetaRouter();
        }
    }

    /**
     * On destroy hook
     */
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
        this.unsubscribeFromMetaRouter();
    }

    unsubscribeFromMetaRouter(): void {
        if (this.metaRouterSubscription) {
            this.metaRouterSubscription.unsubscribe();
        }
    }
}
